import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Cloudy.svg",
  "use": "Cloudy.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"Cloudy.svg\"><path d=\"M49,48H17a10.9933,10.9933,0,0,1-1.6743-21.8593,12.9885,12.9885,0,0,1,23.3416-4.56,9.9654,9.9654,0,0,1,13.3082,8.9331A8.9953,8.9953,0,0,1,49,48Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol